import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import SmoothScroll from "@/components/SmoothScroll";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a192f",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;